import { CircularProgress } from '@mui/material';
import React from 'react';

function Loader() {
  return (
    <div className="loader">
      <CircularProgress color="primary" />
    </div>
  );
}

export default Loader;
